import { render, staticRenderFns } from "./Box19.vue?vue&type=template&id=cc80cd82&scoped=true&"
import script from "./Box19.vue?vue&type=script&lang=js&"
export * from "./Box19.vue?vue&type=script&lang=js&"
import style0 from "./Box19.vue?vue&type=style&index=0&id=cc80cd82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc80cd82",
  null
  
)

export default component.exports